
export function openUrl(url: string): void {
  const os = getMobileOperatingSystem()
  const inWebView = isWebView()
  const customWindow:any = window;
  if (inWebView) {
    if (
      !!customWindow.webkit &&
      !!customWindow.webkit.messageHandlers &&
      customWindow.webkit.messageHandlers.openThirdWeb
    ) {
      customWindow.webkit.messageHandlers.openThirdWeb.postMessage(url)
    } else if (os === 'Android' && !!customWindow.android) {
      customWindow.android.openThirdWeb(url)
    } else {
      console.error('WebView detected but platform is unknown or unsupported.')
    }
  } else {
    customWindow.open(url, '_blank')
  }
}

export function aTagOpenUrl(id: string) {
  const adContent = window.document.getElementById(id)
  const aTag: any = adContent?.getElementsByTagName('a')
  for (let i = 0; i < aTag?.length; i++) {
    aTag[i].addEventListener('click', (event:any) => {
      event.preventDefault()
      const _href = aTag[i].getAttribute('href')
      openUrl(_href)
    })
  }
}

export function removeEventAdd(id: string): void {
  const adContent = window.document.getElementById(id)
  const aTag: any = adContent?.getElementsByTagName('a')
  for (let i = 0; i < aTag?.length; i++) {
    aTag[i].removeEventListener('click', () => {})
  }
}
